module.exports = __webpack_public_path__ + "static/media/SMART-METER.6bd08cd7.png";